"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyClientData = void 0;
function makeEmptyClientData() {
    return {
        id: '',
        identificationType: '',
        gender: '',
        birthday: '',
        maritalStatus: '',
        nationalityId: '',
        names: '',
        lastnames: '',
        address: '',
        email: '',
        pep: false,
        codCli: '0',
        investigated: '',
        phoneGroup: [],
    };
}
exports.makeEmptyClientData = makeEmptyClientData;
//# sourceMappingURL=ClientData.js.map